export const baseUrl = '/mous'
